import React from 'react';
import {FormattedMessage} from 'react-intl';
import {APP_NAMES} from '../../constants';
import {useMapContext} from '../../context/MapContext';

const SleepElement = ({value}) => {
    const mapContext = useMapContext();

    switch (mapContext.appName) {
        case APP_NAMES.TRIPBOARDS:
            return (
                <div
                    className="MapHit__sleeps MapHit__label"
                    aria-hidden="true"
                >
                    {value}
                </div>
            );
        default:
            if (value && value > 0) {
                return (
                    <div
                        className="MapHit__sleeps MapHit__label"
                        aria-hidden="true"
                    >
                        <FormattedMessage
                            id="sleepsAbbreviation"
                            description="sleeps label"
                            defaultMessage="Sleeps {value}"
                            values={{
                                value,
                            }}
                        />
                    </div>
                );
            }
            return null;
    }
};

export default SleepElement;
